import axios from 'axios';

const backendUrl = process.env.VUE_APP_BACKEND_URL_V2;

const authHeaders = () => {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
};

const toResult = (response) =>
  response.data.status === 'ok'
    ? { status: 'ok', data: response.data.data }
    : { status: 'error', message: response.data.message };

const toError = (error) => ({
  status: 'error',
  message: error?.response?.data?.message || 'Error inesperado'
});

export default class PosterAdsService {
  /**
   * Paginated list of poster-ads (benefits carousel of the app).
   * @param {{ page: number, limit: number, visible?: boolean|null, available?: boolean|null, countryId?: string|null }} filters
   */
  static async getAll({ page, limit, visible = null, available = null, countryId = null }) {
    try {
      const params = new URLSearchParams({ page, limit });
      if (visible !== null) params.set('visible', String(visible));
      if (available !== null) params.set('available', String(available));
      if (countryId) params.set('countryId', countryId);
      const response = await axios.get(`${backendUrl}/posterads?${params.toString()}`, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async getById(posterAdId) {
    try {
      const response = await axios.get(`${backendUrl}/posterads/${posterAdId}`, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async create(payload) {
    try {
      const response = await axios.post(`${backendUrl}/posterads`, payload, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async update(posterAdId, payload) {
    try {
      const response = await axios.put(`${backendUrl}/posterads/${posterAdId}`, payload, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }

  static async remove(posterAdId) {
    try {
      const response = await axios.delete(`${backendUrl}/posterads/${posterAdId}`, {
        headers: authHeaders()
      });
      return toResult(response);
    } catch (error) {
      return toError(error);
    }
  }
}
